import { BaseLayout } from "./BaseLayout";
import { GlobalSearchControl } from "Core/GlobalSearchControl";
import { AppContext, DMSMenu } from "Core";
import { NotificationControl } from "Core/NotificationControl";
import { NotificationService } from "Service/NotificationService";
import { TooltipExtension } from "Grids/Extension";

export class StandardMenuLayout extends BaseLayout {
    private static layout = require("./Templates/Menu.html").default;
    private globalSearchControl: GlobalSearchControl;
    private notificationControl: NotificationControl;

    private tooltipExtension: TooltipExtension;

    apply(): void {
        this.setMenuLayout(StandardMenuLayout.layout);
        $("body").removeClass("dms-no-sidemenu");

        if (AppContext.current.environment.IsGlobalSearchEnabled) {
            this.globalSearchControl = new GlobalSearchControl(
                AppContext.current.serviceProvider.GlobalSearch,
                AppContext.current.serviceProvider.TextBlock
            );
            this.globalSearchControl.initialize($(".dms-sidemenu"));
        }

        if (AppContext.current.environment.IsNotificationEnabled) {
            this.notificationControl = new NotificationControl(new NotificationService());
            this.notificationControl.initialize($(".dms-sidemenu"));
        }
        DMSMenu.initialize(AppContext.current.serviceProvider.Menu, AppContext.current.serviceProvider.TextBlock).then(() => {
            this.initializeScroller();
        });

        if (this.tooltipExtension) {
            this.tooltipExtension.dispose();
            this.tooltipExtension = null;
        }
        this.tooltipExtension = new TooltipExtension();
        this.tooltipExtension.initialize($(".dms-sidemenu"));
    }

    resize(): void {
        this.initializeScroller();
    }

    private initializeScroller() {
        $(".dms-scroller").slimScroll({
            height: "auto",
            position: "right",
            size: "5px",
            color: "#9ea5ab",
            wheelStep: 5,
            touchScrollStep: 20,
        });
    }

    dispose(): void {
        super.dispose();

        if (this.globalSearchControl) {
            this.globalSearchControl.dispose();
        }
        if (this.notificationControl) {
            this.notificationControl.dispose();
        }
    }
}
